/** @jsxImportSource @emotion/react */

// TODO: this component should be extended and split into different input types
// Each type should have it's own defaults, styles and tests.
// WARN: no check for `name` - perhaps use tiny-warning to improve DX
export const Input = (props) => <input {...props} />;
